export const question_types_audio_text = [
    { code: 'Audio', label: 'Audio' },
    { code: 'Text', label: 'Text' },
];